import React from 'react';

export default (props) => (
  <svg {...props} width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.582 0.0779762C5.05914 0.0779762 0.582031 4.55509 0.582031 10.078C0.582031 15.6009 5.05914 20.078 10.582 20.078C16.1049 20.078 20.582 15.6009 20.582 10.078C20.582 4.55509 16.1049 0.0779762 10.582 0.0779762Z" fill="#369EFE" />
    <path d="M12.1692 6.81746H13.082V5.15175C12.9245 5.12905 12.3829 5.07798 11.7521 5.07798C8.86405 5.07798 9.64982 8.50456 9.53483 9.00655H8.08203V10.8687H9.53441V15.078H11.3151V10.8691H12.7087L12.93 9.00698H11.3147C11.393 7.77429 10.9976 6.81746 12.1692 6.81746Z" fill="white" />
  </svg>
);
